import { injectable } from "inversify";
import { ImpressionValidator } from '@studyportals/impression-validator';
import { ListName, ListPageType, UniversityCardImpressionData } from '@studyportals/datalake-event-tracker';
import { Tracking } from "./Tracking";
import { ErrorReporter } from "@/infrastructure/ErrorReporter";

@injectable()
export class ImpressionTracking extends Tracking {

	private readonly trackedOrganisationCardIds: number[] = [];

	public constructor(errorReporter: ErrorReporter) {
		super(errorReporter);
	}

	public instantiateImpressionValidatorOn(element: HTMLElement, elementClass: string): void {
		new ImpressionValidator(element, elementClass);
	}

	public track(id: number, position: number): void {
		if (this.isTracked(id)) {
			return;
		}

		try {
			const data: UniversityCardImpressionData = this.constructImpressionData(id, position);
			this.tracker.trackUniversityCardImpression(data);
			this.markIdAsTracked(id);
		} catch (error) {
			this.errorReporter.report(JSON.stringify(error));
		}
	}


	private isTracked(id: number): boolean {
		return this.trackedOrganisationCardIds.includes(id);
	}

	private constructImpressionData(id: number, position: number): UniversityCardImpressionData {
		return new UniversityCardImpressionData(
			id,
			ListPageType.SEARCH,
			ListName.UNIVERSITY_SEARCH_PAGE,
			id,
			position
		);
	}

	private markIdAsTracked(id: number): void {
		this.trackedOrganisationCardIds.push(id);
	}
}
